var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"settings"}},[(_vm.getArtist)?_c('div',_vm._l((_vm.searchArtist),function(song){return _c('ArtistCard',{key:song,attrs:{"song":song}})}),1):_c('NoResult',{attrs:{"title":"No Artist"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }